import { getIntFromApptimize } from 'helpers/getIntFromApptimize'

export const getBrandRefreshPhase = (): number =>
  getIntFromApptimize('brandRefreshPhase', 1)

export const isBrandRefreshEnabled = (): boolean => getBrandRefreshPhase() >= 1
